module.exports = __webpack_public_path__ + "img/eyes.086985b6.png";